import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "@/App";

// SSO callback: persist tokens from the URL fragment BEFORE React mounts,
// so AuthContext initializes with the token instead of wiping storage.
if (window.location.pathname === "/sso/callback" && window.location.hash.length > 1) {
  const params = new URLSearchParams(window.location.hash.slice(1));
  const at = params.get("access_token");
  const rt = params.get("refresh_token");
  if (at && rt) {
    localStorage.setItem("access_token", at);
    localStorage.setItem("refresh_token", rt);
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
